import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EditIcon from '@mui/icons-material/Edit';
import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';
import CopyableTextField from 'components/CopyableTextField';
import SeoRouteJsonParams from 'components/SeoRouteJsonParams';

import { PUBLIC_URL } from 'const';
import { SeoRoutesListRow_seoRoute$key } from '__generated__/SeoRoutesListRow_seoRoute.graphql';
import IconButton from '@mui/material/IconButton';

type Props = EntityTableRowProps & {
  seoRoute: SeoRoutesListRow_seoRoute$key;
};

const types = {
  ALIAS: 'Alias',
  PERMANENT_REDIRECT: '301',
  REDIRECT: '302',
};

const SeoRoutesListRow: FC<Props> = ({ seoRoute, ...props }) => {
  const seoRouteData = useFragment(
    graphql`
      fragment SeoRoutesListRow_seoRoute on SeoRoute {
        id
        type
        sourceUrl
        targetUrl
        packageCount
        monthlySourceVisits
        monthlyDestinationVisits

        ...EntityTableRow_entity
        ...SeoRouteJsonParams_seoRoute
      }
    `,
    seoRoute
  );

  const {
    id,
    type,
    sourceUrl,
    targetUrl,
    packageCount,
    monthlySourceVisits,
    monthlyDestinationVisits,
  } = seoRouteData;

  return (
    <EntityTableRow
      entity={seoRouteData}
      actions={
        <IconButton href={id} size="small">
          <EditIcon color="success" fontSize="small" />
        </IconButton>
      }
      {...props}>
      <TableCell>{types[type]}</TableCell>

      <TableCell center>
        <Link href={`${PUBLIC_URL}${sourceUrl}`}>{sourceUrl}</Link>
      </TableCell>

      <TableCell>
        <CopyableTextField fullWidth value={targetUrl} />
      </TableCell>

      <TableCell center>
        <SeoRouteJsonParams seoRoute={seoRouteData} />
      </TableCell>

      <TableCell center>{packageCount}</TableCell>
      <TableCell center>{monthlySourceVisits}</TableCell>
      <TableCell center>{monthlyDestinationVisits}</TableCell>
    </EntityTableRow>
  );
};

export default SeoRoutesListRow;
